import { RiLoginBoxLine, RiHome6Line, RiGlobalLine, RiGamepadLine, RiBarChart2Line, RiUser2Fill, RiSteamFill } from "react-icons/ri";
import { store } from "../redux/store";




export const menuItems = (site_settings) => {
    
    return [
    {address: '/', show: true, title: 'Home', icon: RiHome6Line},
    {address: '/global', show: true, title: 'AI Trading', icon: RiGlobalLine},
    {address: '/game-home', show: site_settings?.operational_settings?.useGame == 1, title: 'Game', icon: RiGamepadLine},

    {address: '/team', show: true, title: 'Interest', icon: RiSteamFill},
    {address: '/personal-information', show: true, title: 'Mine', icon: RiUser2Fill},
]

}


